import React from "react";

function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clip-path="url(#clip0_1420_3776)">
        <path
          d="M9 3.41582V11.0002C9 11.5533 8.55313 12.0002 8 12.0002C7.44688 12.0002 7 11.5533 7 11.0002V3.41582L4.70625 5.70957C4.31563 6.1002 3.68125 6.1002 3.29063 5.70957C2.9 5.31895 2.9 4.68457 3.29063 4.29395L7.29063 0.293945C7.68125 -0.0966797 8.31563 -0.0966797 8.70625 0.293945L12.7063 4.29395C13.0969 4.68457 13.0969 5.31895 12.7063 5.70957C12.3156 6.1002 11.6812 6.1002 11.2906 5.70957L9 3.41582ZM2 11.0002H6C6 12.1033 6.89687 13.0002 8 13.0002C9.10312 13.0002 10 12.1033 10 11.0002H14C15.1031 11.0002 16 11.8971 16 13.0002V14.0002C16 15.1033 15.1031 16.0002 14 16.0002H2C0.896875 16.0002 0 15.1033 0 14.0002V13.0002C0 11.8971 0.896875 11.0002 2 11.0002ZM13.5 14.2502C13.6989 14.2502 13.8897 14.1712 14.0303 14.0305C14.171 13.8899 14.25 13.6991 14.25 13.5002C14.25 13.3013 14.171 13.1105 14.0303 12.9699C13.8897 12.8292 13.6989 12.7502 13.5 12.7502C13.3011 12.7502 13.1103 12.8292 12.9697 12.9699C12.829 13.1105 12.75 13.3013 12.75 13.5002C12.75 13.6991 12.829 13.8899 12.9697 14.0305C13.1103 14.1712 13.3011 14.2502 13.5 14.2502Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_1420_3776">
          <path d="M0 0H16V16H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UploadIcon;
